import { IconProps } from '.';

const PaperclipIcon = ({ color, customClasses, ...rest }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 40 40"
      fill="none"
      className={customClasses}
      {...rest}
    >
      <g clipPath="url(#clip0_18177_142908)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M26.4974 7.79665C24.5448 5.84403 21.379 5.84403 19.4264 7.79665L9.99829 17.2247C6.74392 20.4791 6.74392 25.7555 9.99829 29.0099C13.2527 32.2642 18.529 32.2642 21.7834 29.0099L30.3276 20.4656L32.0954 22.2334L23.5512 30.7776C19.3205 35.0083 12.4612 35.0083 8.23052 30.7776C3.99984 26.5469 3.99984 19.6877 8.23052 15.457L17.6586 6.02889C20.5875 3.09995 25.3363 3.09995 28.2652 6.02889C31.1941 8.95782 31.1941 13.7066 28.2652 16.6355L18.8371 26.0636C17.2099 27.6908 14.5718 27.6908 12.9446 26.0636C11.3174 24.4364 11.3174 21.7982 12.9446 20.171L22.078 11.0376L23.8458 12.8053L14.7123 21.9388C14.0615 22.5897 14.0615 23.6449 14.7123 24.2958C15.3632 24.9467 16.4185 24.9467 17.0694 24.2958L26.4974 14.8677C28.4501 12.9151 28.4501 9.74927 26.4974 7.79665Z"
          fill={color || 'var(--color-ui-icon-primary)'}
        />
      </g>
      <defs>
        <clipPath id="clip0_18177_142908">
          <rect
            width="40"
            height="40"
            fill={color || 'var(--color-ui-icon-primary)'}
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default PaperclipIcon;
